import { deriveClaimStartDate, deriveFormattedDateRange } from '~support-at-home/lib/derive';

import { Step } from '~components/wizard-form/props';

import { selectAppointmentStatuses } from '~appointments/selectors/statuses';
import { selectClientFormOptions } from '~lookups/selectors/clientFormOptions';

import { ClaimDetailsNew, Summary } from '../../components/claims/claims-wizard';

const steps: Step[] = [
  {
    step: 1,
    title: 'Setup',
    fields: {
      end_date: {
        type: 'date',
        field: 'end_date',
        caption: 'Claim Date',
        description: 'Claim items up to this date within the relavent quarter',
        required: true,
        onChange: deriveClaimStartDate,
        className: 'align-items-baseline',
      },
      start_date: {
        type: 'hidden',
        field: 'start_date',
      },
      claim_range: {
        type: 'readonly',
        field: 'claim_range',
        caption: 'Claim Range',
        deriveValue: deriveFormattedDateRange,
        className: 'align-items-baseline',
        dependencies: ['start_date', 'end_date'],
      },
      status_id: {
        type: 'multi-lookup',
        field: 'status_id',
        caption: 'Appointment Status',
        description: 'Limit appointment claim items to appointments in specific statuses (blank for all statuses)',
        className: 'align-items-baseline',
        placeholder: 'All Statuses',
        selectorOptions: selectAppointmentStatuses,
      },
      naps_id: {
        type: 'multi-lookup',
        field: 'naps_id',
        caption: 'Client NAPS ID',
        description: 'Limit claim items to clients with the specified NAPS IDs (blank for all clients)',
        className: 'align-items-baseline',
        placeholder: 'All Clients',
        selectorOptions: selectClientFormOptions,
      },
    },
  },
  {
    step: 2,
    title: 'Review',
    nextButtonCaption: 'Confirm/Proceed',
    fields: {
      summary: {
        type: 'custom',
        component: Summary,
        colSize: 12,
        dependencies: ['start_date', 'end_date', 'naps_id', 'status_id'],
      },
      warning: {
        type: 'alert-warning',
        deriveValue: () =>
          'Caution: If you proceed, a draft claim will be created with item lines for each appointment / invoice line found.',
        colSize: 12,
      },
    },
    // disabled for now - resolution TBD
    // showNextButton: ({ values }) => {
    //   // Only allow next step if there are claim items to generate
    //   const estimateData = values?.summary?.data;
    //   return estimateData?.total > 0;
    // },
  },
  {
    step: 3,
    title: 'Details',
    showPrevButton: false,
    fields: {
      details: {
        type: 'custom',
        component: ClaimDetailsNew,
        colSize: 12,
        dependencies: ['start_date', 'end_date', 'naps_id', 'status_id'],
      },
    },
  },
];

export default steps;
